module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-without-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "unnumbered-1",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "text",
    attrs: {
      "id": "unnumbered-1-text"
    }
  }, [_c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Jonni K")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("The Ungendered Tour of Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('b', [_vm._v("Calendar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Monday 05 Feb — Travel day, crew only — London")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Tuesday 06 — Travel day — London")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Wednesday 07 — ISSTADION — Stockholm")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Thursday 08 — Day off — Copenhagen")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Friday 09 — FORUM — Copenhagen")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Saturday 10 — SPORTHALLE — Hamburg")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Sunday 11 — Day off — Hamburg")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Monday 12 — SEIDENSTICKER HALLE — Bielefeld")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Tuesday 13 — Day off — Berlin")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Wednesday 14 — VELODROM — Berlin")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Thursday 15 — MITSUBISHI ELECTRIC HALLE —Dusseldorf")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Friday 16 — Day off — Amsterdam/Rotterdam")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Saturday 17 — AHOY — Rotterdam")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Sunday 18 — FOREST NATIONAL — Brussels")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Monday 19 — Day off — Brussels/Frankfurt")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Tuesday 20 — FESTHALLE — Frankfurt")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Wednesday 21 — ARENA — Nuremberg")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Thursday 22 — Day off — Stuttgart")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Friday 23 — MARTINSHLEYERHALLE — Stuttgart")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Saturday 24 — OLYMPIAHALLE — Munich")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Sunday 25 — Travel day — Vienna")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Monday 26 — Day off — Vienna")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Tuesday 27 — STADTHALLE — Vienna")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Wednesday 28 — Travel day — Paris")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Thursday 29 — ZENITH — Paris")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_vm._v("Friday 01 Mar — Travel day — Home")])])]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-left"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-left"
  }, [_c('i', [_vm._v("Official tour lists of the Band and the Crew are at the back of the book.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a835154e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/the-ungendered-tour-of-europe.vue
// module id = 72
// module chunks = 0